import {
  FieldProps,
  FormFieldTypes,
  FormModes,
  IBaseFormField,
  IFieldFocusStyle,
  SelectionTypes,
} from "./components/FormFieldSelector/interfaces";
import { IFieldsMap, IForm, visibilityType } from "@common/redux/formBuilder/interface";
import {
  IFieldSubmissionMap,
  IFormFieldSubmission,
  IFormSubmission,
} from "@common/redux/formSubmission/interface";
import { validateTextInputFieldSubmissionData } from "./components/FormTextInputField/rules/utils";
import { validateDropdownFieldSubmissionData } from "./components/FormDropdownField/rules/utils";
import { validateTextAreaFieldSubmissionData } from "./components/FormTextAreaField/rules/utils";
import { validateDateFieldSubmissionData } from "./components/FormDateField/rules/utils";
import { validateTimePickerFieldSubmissionData } from "./components/FormTimePickerField/rules/utils";
import { validateMultipleChoicesFieldSubmissionData } from "./components/FormMultipleChoicesField/rules/utils";
import { validateLinearScaleFieldSubmissionData } from "./components/FormLinearScaleField/rules/utils";
import { validateFileUploadFieldSubmissionData } from "./components/FormFileUploadField/rules/utils";
import { validateCurrencyFieldSubmissionData } from "./components/FormCurrencyField/rules/utils";
import { IFieldRuleConfig } from "./Rules/config";
import { ICurrencyRule } from "./components/FormCurrencyField/rules/FieldRuleStructure";
import { DataMappingUtils } from "@utils/DataMappingUtils";
import { validateDateTimePickerFieldSubmissionData } from "./components/FormDateTimePickerField/rules/utils";
import { validateRatingFieldSubmissionData } from "./components/FormRatingField/rules/utils";
import { validateCheckBoxFieldSubmissionData } from "./components/FormCheckboxField/utils";
import {
  validateFormulaFieldData,
  validatePaymentFieldData,
  validatePaymentFieldSubmissionData,
} from "./components/FormPaymentInputField/utils/fieldUtils";
import { IOption } from "@erelego/design-system/components/atoms/DropdownSelect";
import { validateNumberInputFieldSubmissionData } from "./components/FormNumberInputField/utils";
import { IColor } from "@erelego/design-system/theme/defaultTheme/interface";
import { IDropdownType, ISubmissionType } from "./FileTypeExtensionInterface";
import { descriptionType } from "./components/utils";
import { validateLookupFieldSubmissionData } from "./components/FormLookupField/utils";
import { validateGeolocationFieldSubmissionData } from "./components/FormGeolocationField/utils";
import { validateSignatureFieldSubmissionData } from "./components/FormSignatureComponent/utils";
import { validateDoublePanelFieldSubmissionData } from "./components/FormDoublePanelField/utils";
import { Category, ITemplate } from "@presentation/Templates/interface";
import { useTranslation } from "react-i18next";
import { validateYearSelectorFieldSubmissionData } from "./components/FormYearsDropdown/utils";
import { validateCaptchaFieldSubmissionData } from "./components/FormCaptchaField/utils";
import { validatelinkedDropdownFieldSubmissionData } from "./components/FormLinkedDropdownField/utils";
import { validateRichTextDescriptionFieldSubmissionData } from "./components/DescriptionField/utils";
export type TFunction = (key: string, options?: Record<string, any>) => string;

interface IPaymentType {
  paymentValue?: {
    amount?: string;
  };
}
interface Grid {
  localId: string;
  fieldType: string;
  fields: string[];
}
interface IFieldConfig {
  [key: string]: string[];
}
export const getHiddenFieldIds = (data: IFieldConfig) => {
  const hiddenFieldIds = [];
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      if (data[key].includes("HIDE")) {
        hiddenFieldIds.push(key);
      }
    }
  }
  return hiddenFieldIds;
};

const isPaymentObject = (value: unknown): value is IPaymentType => {
  return (
    typeof value === "object" &&
    value["paymentValue"] &&
    typeof value["paymentValue"] === "object"
  );
};

export const formFieldInitialSubmissionValues = (
  fieldId: string,
  fieldData: FieldProps
) => {
  
  let fieldSubmissionValue: Object;
  const fieldValueData = fieldData?.fieldValue || {};
  const isSection: boolean = fieldData?.isSection;
  let fields: string[];
  switch (FormFieldTypes[fieldData?.fieldType]) {
    case FormFieldTypes.TEXT_INPUT:
      fieldSubmissionValue = {
        // @ts-ignore
        value: fieldValueData?.value || fieldValueData?.initialValue || "",
      };
      break;
    case FormFieldTypes.FORM_LINK:
      fieldSubmissionValue = {
        // @ts-ignore
        value: fieldValueData?.value || fieldValueData?.initialValue || "",
      };
      break;
    case FormFieldTypes.NUMBER_INPUT:
      fieldSubmissionValue = {
        // @ts-ignore
        value: fieldValueData?.value || fieldValueData?.initialValue || "",
      };
      break;
    case FormFieldTypes.PIN_CODE:
      fieldSubmissionValue = {
        // @ts-ignore
        value: fieldValueData?.value || fieldValueData?.initialValue || "",
      };
      break;
    case FormFieldTypes.DROPDOWN:
      // @ts-ignore
      if (fieldValueData?.selectedType == SelectionTypes?.MULTIPLE_SELECTION) {
        fieldSubmissionValue = {
          // @ts-ignore
          selectedOptions: fieldValueData?.selectedOptions || [],
        };
      } else {
        fieldSubmissionValue = {
          // @ts-ignore
          selectedOption: fieldValueData?.selectedOption || {},
        };
      }
      break;
    case FormFieldTypes.TEXT_AREA:
      fieldSubmissionValue = {
        // @ts-ignore
        value: fieldValueData?.value || fieldValueData?.initialValue || "",
      };
      break;
    case FormFieldTypes.DATE_INPUT:
      fieldSubmissionValue = {
        // @ts-ignore
        value: fieldValueData?.value || fieldValueData?.initialValue || "",
      };
      break;
    case FormFieldTypes.LOOKUP:
      fieldSubmissionValue = {
        // @ts-ignore
        selectedOption: fieldValueData?.value || "",
      };
      break;
    case FormFieldTypes.TIME_PICKER:
      fieldSubmissionValue = {
        // @ts-ignore
        value: fieldValueData?.value || fieldValueData?.initialValue || "",
      };
      break;
    case FormFieldTypes.MULTIPLE_CHOICES:
      // @ts-ignore
      if (fieldValueData?.selectedType == SelectionTypes?.MULTIPLE_SELECTION) {
        fieldSubmissionValue = {
          // @ts-ignore
          selectedOptions: fieldValueData?.selectedOptions || [],
        };
      } else {
        fieldSubmissionValue = {
          // @ts-ignore
          selectedOption: fieldValueData?.selectedOption || {},
        };
      }
      break;
    case FormFieldTypes.LINEAR_SCALING:
      fieldSubmissionValue = {
        // @ts-ignore
        selectedOption:
          fieldValueData?.selectedOption || fieldValueData?.initialValue || "",
      };
      break;
    case FormFieldTypes.FILE_UPLOAD:
      fieldSubmissionValue = {
        // @ts-ignore
        uploadedFiles: fieldValueData?.uploadedFiles || [],
      };
      break;

    case FormFieldTypes.CURRENCY:
      fieldSubmissionValue = {
        // @ts-ignore
        value: fieldValueData?.value || fieldValueData?.initialValue || "",
      };
      break;
    case FormFieldTypes.DATE_TIME_PICKER:
      fieldSubmissionValue = {
        // @ts-ignore
        value: fieldValueData?.value || fieldValueData?.initialValue || "",
      };
      break;
    case FormFieldTypes.RATING:
      fieldSubmissionValue = {
        // @ts-ignore
        value: fieldValueData?.value || 0,
      };
      break;

    case FormFieldTypes.CHECK_BOX:
      fieldSubmissionValue = {
        // @ts-ignore
        checkBoxValue: fieldValueData?.value,
      };
      break;
    case FormFieldTypes.PAYMENT:
      // @ts-ignore
      const fieldValue =
        fieldValueData?.paymentValue?.amount ||
        fieldValueData?.transactionAmount ||
        "";
      const selectedPaymentId = fieldValueData?.paymentId?.[0] || "";
      fieldSubmissionValue = {
        paymentValue: {
          amount: fieldValue,
          selectedPaymentId: selectedPaymentId,
        },
      };
      break;
    case FormFieldTypes.GEOLOCATION:
      // @ts-ignore
      fieldSubmissionValue = {
        geolocationValue: {
          latitude: "",
          longitude: "",
          address: "",
        },
      };
      break;
    case FormFieldTypes.GEOLOCATION:
      // @ts-ignore
      fieldSubmissionValue = {
        dataGridValue: {
          columnId: {},
          columnId2: {},
        },
      };
      break;

    case FormFieldTypes.CALCULATIVE:
      fieldSubmissionValue = {
        // @ts-ignore
        value: fieldValueData?.value ?? fieldValueData?.initialValue ?? "",
      };
      break;

    case FormFieldTypes.SIGNATURE_BOX:
      fieldSubmissionValue = {
        // @ts-ignore
        value: fieldValueData?.value || fieldValueData?.initialValue || "",
      };
      break;

    case FormFieldTypes.DOUBLE_PANEL:
      fieldSubmissionValue = {
        // @ts-ignore
        value: fieldValueData?.value || fieldValueData?.initialValue || "",
      };
      break;
    case FormFieldTypes.LINKED_DROPDOWN:
      fieldSubmissionValue = {
        // @ts-ignore
        value: fieldValueData?.value || fieldValueData?.initialValue || "",
      };
      break;

    default:
      fieldSubmissionValue = {
        // @ts-ignore
        value: fieldValueData?.value ?? fieldValueData?.initialValue ?? "",
      };
      break;
  }

  const fieldInitialization = {
    localId: fieldId,
    isSection: isSection,
    fieldType: fieldData?.fieldType,
    fields: fields,
    fieldSubmissionValue: fieldSubmissionValue,
    isError: false,
    valueError: "",
  };

  return fieldSubmissionValue && fieldInitialization;
};

export const filterHiddenFields = (
  hiddenFields: string[],
  rules: IFieldRuleConfig[]
) => {
  return rules?.filter((rule: IFieldRuleConfig) => {
    if (
      rule.valueType === "dynamic" &&
      (hiddenFields ?? [])?.includes(rule.dynamicValueFieldId)
    ) {
      return false; // Remove the rule if dynamicValueFieldId is in hiddenFields
    }
    return true; // Keep the rule otherwise
  });
};

export const fieldTypeValidation = (
  fieldData: FieldProps,
  fieldSubmissionValue: IFormFieldSubmission,
  fieldSubmissionMap: IFieldSubmissionMap,
  bulkUpdateSubmissionValues: (fieldIds: string[], fieldsMap: object[]) => void
): [boolean, string] => {
  let isValidated = true;
  let errorMessage = "";
  switch (FormFieldTypes[fieldData?.fieldType]) {
    case FormFieldTypes.TEXT_INPUT:
      [isValidated, errorMessage] = validateTextInputFieldSubmissionData(
        fieldData,
        fieldSubmissionValue,
        fieldSubmissionMap
      );
      break;
    case FormFieldTypes.NUMBER_INPUT:
      [isValidated, errorMessage] = validateNumberInputFieldSubmissionData(
        fieldData,
        fieldSubmissionValue,
        fieldSubmissionMap
      );
      break;
    case FormFieldTypes.CAPTCHA:
      [isValidated, errorMessage] = validateCaptchaFieldSubmissionData(
        fieldData,
        fieldSubmissionValue,
        fieldSubmissionMap
      );
      break;
    case FormFieldTypes.DESCRIPTION:
      [isValidated, errorMessage] = validateRichTextDescriptionFieldSubmissionData(
        fieldData,
        fieldSubmissionValue,
        fieldSubmissionMap
      );
      break;
    case FormFieldTypes.PIN_CODE:
      [isValidated, errorMessage] = validateNumberInputFieldSubmissionData(
        fieldData,
        fieldSubmissionValue,
        fieldSubmissionMap
      );
      break;

    case FormFieldTypes.DROPDOWN:
      [isValidated, errorMessage] = validateDropdownFieldSubmissionData(
        fieldData,
        fieldSubmissionValue,
        fieldSubmissionMap
      );
      break;
    case FormFieldTypes.TEXT_AREA:
      [isValidated, errorMessage] = validateTextAreaFieldSubmissionData(
        fieldData,
        fieldSubmissionValue,
        fieldSubmissionMap
      );
      break;
    case FormFieldTypes.DATE_INPUT:
      [isValidated, errorMessage] = validateDateFieldSubmissionData(
        fieldData,
        fieldSubmissionValue,
        fieldSubmissionMap
      );
      break;
    case FormFieldTypes.TIME_PICKER:
      [isValidated, errorMessage] = validateTimePickerFieldSubmissionData(
        fieldData,
        fieldSubmissionValue,
        fieldSubmissionMap
      );
      break;
    case FormFieldTypes.MULTIPLE_CHOICES:
      [isValidated, errorMessage] = validateMultipleChoicesFieldSubmissionData(
        fieldData,
        fieldSubmissionValue,
        fieldSubmissionMap
      );
      break;
    case FormFieldTypes.LINEAR_SCALING:
      [isValidated, errorMessage] = validateLinearScaleFieldSubmissionData(
        fieldData,
        fieldSubmissionValue,
        fieldSubmissionMap
      );
      break;
    case FormFieldTypes.FILE_UPLOAD:
      [isValidated, errorMessage] = validateFileUploadFieldSubmissionData(
        fieldData,
        fieldSubmissionValue,
        fieldSubmissionMap
      );
      break;
    case FormFieldTypes.CURRENCY:
      [isValidated, errorMessage] = validateCurrencyFieldSubmissionData(
        fieldData,
        fieldSubmissionValue,
        fieldSubmissionMap
      );
      break;
    case FormFieldTypes.DATE_TIME_PICKER:
      [isValidated, errorMessage] = validateDateTimePickerFieldSubmissionData(
        fieldData,
        fieldSubmissionValue,
        fieldSubmissionMap
      );
      break;
    case FormFieldTypes.RATING:
      [isValidated, errorMessage] = validateRatingFieldSubmissionData(
        fieldData,
        fieldSubmissionValue,
        fieldSubmissionMap
      );
      break;
    case FormFieldTypes.CHECK_BOX:
      [isValidated, errorMessage] = validateCheckBoxFieldSubmissionData(
        fieldData,
        fieldSubmissionValue
      );
      break;
    case FormFieldTypes.GEOLOCATION:
      [isValidated, errorMessage] = validateGeolocationFieldSubmissionData(
        fieldData,
        fieldSubmissionValue
      );
      break;
    case FormFieldTypes.PAYMENT:
      [isValidated, errorMessage] = validatePaymentFieldSubmissionData(
        fieldData,
        fieldSubmissionValue,
        fieldSubmissionMap,
        bulkUpdateSubmissionValues
      );
      break;

    case FormFieldTypes.LOOKUP:
      [isValidated, errorMessage] = validateLookupFieldSubmissionData(
        fieldData,
        fieldSubmissionValue
      );
      break;

    case FormFieldTypes.DOUBLE_PANEL:
      [isValidated, errorMessage] = validateDoublePanelFieldSubmissionData(
        fieldData,
        fieldSubmissionValue,
        fieldSubmissionMap
      );
      break;

    case FormFieldTypes.SIGNATURE_BOX:
      [isValidated, errorMessage] = validateSignatureFieldSubmissionData(
        fieldSubmissionValue,
      );
      break;

    case FormFieldTypes.YEAR_SELECTOR:
      [isValidated, errorMessage] = validateYearSelectorFieldSubmissionData(
        fieldData,
        fieldSubmissionValue,
      );
      break;
    case FormFieldTypes.LINKED_DROPDOWN:
      [isValidated, errorMessage] = validatelinkedDropdownFieldSubmissionData(
        fieldData,
        fieldSubmissionValue,
        fieldSubmissionMap
      );
      break;
    case FormFieldTypes.LINKED_DROPDOWN:
      [isValidated, errorMessage] = validatelinkedDropdownFieldSubmissionData(
        fieldData,
        fieldSubmissionValue,
        fieldSubmissionMap
      );
      break;

    // is the required validation is required in geolocation
    default:
      break;
  }
  return [isValidated, errorMessage];
};

export const formSubmissionInitialization = (
  formData: IForm,
  formSubmissionData: IFormSubmission
) => {
  const existingFormEditData: IForm = formData;

  const existingFormSubmissionData: IFormSubmission = formSubmissionData;

  const initialFormEditFieldsMap =
    (existingFormEditData && existingFormEditData?.fieldsMap) || {};

  const initialFieldSubmissionMap: IFieldSubmissionMap =
    (existingFormSubmissionData &&
      existingFormSubmissionData.fieldSubmissionMap) ||
    {};
  Object.keys(initialFormEditFieldsMap)?.map((fieldId: string) => {
    const fieldEditConfig = initialFormEditFieldsMap[fieldId];

    if (!initialFieldSubmissionMap[fieldId]) {
      const fieldInitialization = formFieldInitialSubmissionValues(
        fieldId,
        fieldEditConfig
      );

      initialFieldSubmissionMap[fieldId] = fieldInitialization;
    }
  });
  return initialFieldSubmissionMap;
};

export const validateSubRule = (
  fieldRule: IFieldRuleConfig | ICurrencyRule,
  submissionValue: any,
  fieldSubmissionMap: IFieldSubmissionMap,
  validateRule: (
    fieldRule: IFieldRuleConfig,
    submissionValue: any,
    fieldSubmissionMap: IFieldSubmissionMap
  ) => any //need to ask sir
): [boolean, string] => {
  for (let i = 0; i < fieldRule?.subRules?.length; i++) {
    const [isValidated, validatationErrorMessage] = validateRule(
      fieldRule?.subRules[i],
      submissionValue,
      fieldSubmissionMap
    );
    if (!isValidated && validatationErrorMessage != "") {
      return [isValidated, validatationErrorMessage];
    }
  }
  return [true, ""];
};
export const getHiddenFields = (data: IFieldsMap) => {
  const hiddenFieldIds = [];
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      if (!data[key]?.isVisible) {
        if (key && key != "undefined") {
          hiddenFieldIds.push(key);
        }
      }
    }
  }
  return hiddenFieldIds;
};
export const validateFormFields = (
  fields: string[],
  fieldsMap: IFieldsMap,
  fieldSubmissionMap: IFieldSubmissionMap,
  focusFieldId: string | undefined,
  bulkUpdateSubmissionValues: (fieldIds: string[], fieldsMap: object[]) => void,
  fieldsToHide: string[],
  updatedHiddenFields?: string[]
): [boolean, string | undefined] => {
  let isValid = true;

  const fieldIDsData: string[] = [];

  const fieldsMapData: object[] = [];
  const dataGrids = Object.values(fieldsMap ?? {})
    .filter((elem) => elem.fieldType === "DATA_GRID")
    .reduce(
      (acc, grid) => {
        acc[grid.localId] = {
          ...grid,
          localId: grid?.localId,
          fields: grid?.fields ?? [],
          fieldsSet: new Set(grid.fields || []),
        };
        return acc;
      },
      {} as Record<string, { localId: string; fields: string[]; fieldsSet: Set<string> }>
    );

  fields?.map((fieldId: string, index: number) => {
    if (fieldsToHide.includes(fieldId)) return;
    const fieldData = fieldsMap[fieldId];
    const updateRuleData = filterHiddenFields(
      updatedHiddenFields,
      fieldData.rules
    );
    const parentDataGrid = Object.values(dataGrids).find(grid =>
      grid.fieldsSet.has(fieldId)
    );
    let updateFieldData = {
      ...fieldData,
      rules: updateRuleData,
    };
    if (fieldData.isSection || fieldData.fields.length > 0) {
      const sectionFields = fieldData.fields || [];
      let isSubFormValidated = true;
      [isSubFormValidated, focusFieldId] = validateFormFields(
        sectionFields,
        fieldsMap,
        fieldSubmissionMap,
        focusFieldId,
        bulkUpdateSubmissionValues,
        fieldsToHide
      );
      if (!isSubFormValidated) {
        isValid = false;
      }
    }
    let fieldSubmissionValue: any;
    if (parentDataGrid) {
      const dataGridSubmission = fieldSubmissionMap[parentDataGrid.localId]?.fieldSubmissionValue?.dataGridValue || {};
      const dataGridRows = Object.values(dataGridSubmission);
      let isFieldValidInAllRows = true;
      for (const row of dataGridRows) {
        const value: any = row?.[fieldId] ?? {};
        fieldSubmissionValue = value
        const [isValidated, errorMessage] = fieldTypeValidation(
          updateFieldData,
          value,
          fieldSubmissionMap,
          bulkUpdateSubmissionValues
        );

        if (!isValidated) {
          isFieldValidInAllRows = false;
          isValid = false;
          !focusFieldId && (focusFieldId = fieldId);

          row[fieldId] = {
            ...row[fieldId],
            isError: !isValidated,
            valueError: errorMessage,
            localId: fieldId,
            fieldType: fieldData.fieldType,
            columnId: Object.keys(row)[0]
          }

          fieldsMapData.push({
            fieldSubmissionValue: {
              dataGridValue: dataGridSubmission
            },
            localId: parentDataGrid.localId,
            fieldType: FormFieldTypes.DATA_GRID,
            isError: true,
            valueError: errorMessage,
          });
        }
      }
    } else if (!fieldSubmissionMap[fieldId]) {
      const fieldInitialization = formFieldInitialSubmissionValues(
        fieldId,
        fieldData
      );

      fieldIDsData.push(fieldId);
      fieldInitialization && fieldsMapData.push(fieldInitialization);
      fieldSubmissionValue = fieldInitialization;
    } else {
      fieldSubmissionValue = fieldSubmissionMap[fieldId];
    }
    const [isValidated, errorMessage] = fieldTypeValidation(
      updateFieldData,
      fieldSubmissionValue,
      fieldSubmissionMap,
      bulkUpdateSubmissionValues
    );

    if (!isValidated) {
      isValid = false;
      !focusFieldId && (focusFieldId = fieldId);
      if (!fieldSubmissionMap[fieldId]) {
        const fieldInitialization = {
          localId: fieldId,
          fieldType: fieldData.fieldType,
          isError: !isValidated,
          valueError: errorMessage,
        };
        fieldIDsData.push(fieldId);
        fieldsMapData.push(fieldInitialization);
      } else {
        fieldsMapData.push({
          ...fieldSubmissionMap[fieldId],
          isError: !isValidated,
          valueError: errorMessage,
        });
      }
    }
  });

  bulkUpdateSubmissionValues(fieldIDsData, fieldsMapData);
  return [isValid, focusFieldId];
};

export enum uniqueIdType {
  RULE = "rule-id-",
  SUBRULE = "sub-rule-id",
  SUBFORM = "sub-form-id-",
  FIELD = "field_id_",
  CONDITION = "condition-id-",
  SECTION = "section_id_",
  WIDGET = "widget-id-",
  COLUMN = "column-id-",
}

export const generateUniqueId = (idType: uniqueIdType, prefix = "") => {
  const uniqueIdPrefix = prefix ? `_${prefix}` + "_" : "_";
  const uniqueId = uniqueIdPrefix + idType + DataMappingUtils.generateUuidv4();
  return uniqueId;
};
export const focusField = (inputRef: React.RefObject<HTMLInputElement>) => {
  setTimeout(() => {
    inputRef?.current?.focus?.();
  }, 1);
};

export const scrollToField = (
  ref: React.RefObject<HTMLInputElement | HTMLDivElement>,
  block?: ScrollLogicalPosition
) => {
  const blockedString = block ?? "center";
  setTimeout(() => {
    ref?.current?.scrollIntoView({
      behavior: "smooth",
      block: blockedString,
      inline: blockedString,
    });
  }, 1);
};

export const isFieldInViewMode = (formMode: string): boolean => {
  if (
    formMode === FormModes.view ||
    formMode === FormModes.preview ||
    formMode === FormModes.responseView
  ) {
    return true;
  } else {
    return false;
  }
};

export const getFieldFocusStyle = (data: IFieldFocusStyle) => {
  return data.isEditingField && data.isDisabled
    ? "field-focus-style"
    : "field-unfocus-style";
};

export const getLabelColor = (
  isError: boolean,
  isResponseMode: boolean,
  color: IColor
) => {
  let labelColor = color.defaultTextColor;
  if (isResponseMode) {
    labelColor = color.neutral200;
  }
  if (isError) {
    labelColor = color.error;
  }
  return labelColor;
};

export const defaultFormFieldData: IBaseFormField = {
  localId: "",
  grid: {
    width: 6,
  },
  fieldValue: {},
  fieldType: "",
  isSection: false,
  settings: { visibility: { isVisible: true, isDisabled: false } },
  isRequired: false,
  title: "",
  description: "",
  isDuplicateAllowed: true,
  descriptionType: descriptionType?.TOOLTIP,
  isPII: false,
  isDisabled: false,
  prefix: "",
  postfix: "",
  eyeIcon: false,
  completeEncrypt: false,
};

export const checkIsFormEmpty = (
  formData: IForm,
  setFieldEditorFocus: (fieldId: string, isFieldFocused: boolean) => void,
  isOverviewAllowed: boolean
): string => {
  const overviewForm = formData?.overviewForm;
  const subForms = formData?.subForms || [];
  const subFormsMap = formData?.subFormsMap || {};
  const fieldsMap = formData?.fieldsMap || {};

  let errorMessage = "";
  if (isOverviewAllowed && overviewForm?.length == 0) {
    return "Form should have atleast one field to continue";
  }

  for (let index = 0; index < subForms.length; index++) {
    const subFormId = subForms[index];
    const subFormData = subFormsMap[subFormId];
    const subFormFields = subFormData?.fields || [];
    if (
      subFormId &&
      subFormData &&
      subFormFields &&
      subFormFields?.length == 0
    ) {
      errorMessage = `Page${index + 1
        } should have atleast one field to continue.`;
      break;
    }
  }

  // for (const fieldId in fieldsMap) {
  //   const fieldData = fieldsMap[fieldId];
  // have to fix the logic
  // if (fieldData?.fieldType == FormFieldTypes.SECTION) {
  //   const fields = fieldData?.fields || [];
  //   if (fields?.length == 0) {
  //     setFieldEditorFocus(fieldId, true);
  //     return "Form cannot be saved with an empty section";
  //   }
  // }
  // }

  return errorMessage;
};

export const checkIsPaymentConfigCompleted = (formData: IForm): boolean => {
  const fieldsMap = formData?.fieldsMap;

  for (const fieldId in fieldsMap) {
    const fieldData = fieldsMap[fieldId];
    if (fieldData.fieldType == FormFieldTypes.PAYMENT) {
      const isFieldConfigDataValidated = validatePaymentFieldData(
        fieldData?.fieldValue
      );
      return isFieldConfigDataValidated;
    }
  }
  return true;
};

export const checkIsFormulaFieldConfigCompleted = (
  formData: IForm
): boolean => {
  const fieldsMap = formData?.fieldsMap;

  for (const fieldId in fieldsMap) {
    const fieldData = fieldsMap[fieldId];
    if (fieldData.fieldType == FormFieldTypes.CALCULATIVE) {
      const isFieldConfigDataValidated = validateFormulaFieldData(
        fieldData?.fieldValue
      );
      return isFieldConfigDataValidated;
    }
  }
  return true;
};

export const getDropdownOptions = (options: any): IOption[] => {
  const dropdownOptions: IOption[] = [];
  for (const key of Object.keys(options)) {
    const option = options[key];
    const value = option?.dropdownOptionKey || option?.optionKey || "";
    const content = option?.dropdownOptionValue || option?.optionValue || "";
    if (value === "" || content === "") {
      continue;
    }
    dropdownOptions.push({ value, content });
  }
  return dropdownOptions;
};

const isDropdownType = (
  submissionValue: unknown
): submissionValue is IDropdownType => {
  return typeof submissionValue["selectedOption"] === "object";
};

const isSubmissionType = (data: unknown): data is ISubmissionType => {
  return typeof data === "object";
};

export const getReferenceValueFromSubmission = (data: any) => {
  if (isSubmissionType(data) && typeof data.fieldSubmissionValue === "object") {
    if (isDropdownType(data["fieldSubmissionValue"])) {
      return data?.fieldSubmissionValue?.selectedOption?.optionKey ?? "";
    }
  }
  return "";
};

export const getDefaultFormConfig = (
  totalFormsSelector,
  folderPath: string,
  templateData?: ITemplate,
) => {

  const { id, fields, subForms } = templateData ?? {}
  const subformId = generateUniqueId(uniqueIdType.SUBFORM, "");

  const formData = {
    fields: fields ?? [],
    title: `Change Title`,
    themeId: "",
    enableFieldNumbering: true,
    isOverviewAllowed: false,
    isMultipleSubAllowed: true,
    sendEmailAlerts: false,
    folderPath: folderPath,
    subForms: subForms ?? [
      {
        localId: `${subformId}`,
        title: "Page 1",
        fields: [],
      },
    ],
    visibility: visibilityType?.PRIVATE,
    isCompositeKeyEnabled: false,
    compositeKeyFields: [],

    textKeyField: "",
    sourceTemplateId: id,
    fieldCount: 0
  };
  return formData;
};
export const getUpdatedSubFormsArray = (
  subForms: string[] = [],
  hiddenForms: string[] = []
): string[] => {
  const updatedFormsData: string[] = [];
  for (const form of subForms) {
    if (!hiddenForms?.includes(form)) {
      updatedFormsData?.push(form);
    }
  }
  return updatedFormsData;
};
export const concatenateArrays = (
  arr1: string[],
  arr2: string[],
  arr3: string[]
): string[] => {
  const concatenatedSet = new Set([
    ...(arr1 || []),
    ...(arr2 || []),
    ...(arr3 || []),
  ]);
  const concatenatedArray = Array.from(concatenatedSet);
  return concatenatedArray;
};
export enum ConditionType {
  system_fields = "system_fields",
  user_field = "user_field",
  form_field = "form_field",
  data_field = "data_field",
  custom_field = "custom_field",
  user_attributes = "user_attributes",
  system_field = "system_field",

}

export const getIOption = (valueToFind: string, options: IOption[]) => {
  for (const option of options) {
    if (option.value === valueToFind) {
      return option;
    }
  }
  return null;
};

export const categoryMapData = (t: TFunction) => {
  return [
    { id: 1, name: t('business'), value: 'BUSINESS' },
    { id: 2, name: t('reservation'), value: 'RESERVATION' },
    { id: 3, name: t('booking'), value: 'BOOKING' },
    { id: 4, name: t('leadGeneration'), value: 'LEAD_GENERATION' },
    { id: 5, name: t('humanResources'), value: 'HUMAN_RESOURCES' },
    { id: 6, name: t('requests'), value: 'REQUESTS' },
    { id: 7, name: t('construction'), value: 'CONSTRUCTION' },
    { id: 8, name: t('eCommerce'), value: 'E_COMMERCE' },
  ];
};

export const getStyle = (isCurrentFieldHidden, actualFormMode) => {
  return { display: (isCurrentFieldHidden && actualFormMode != FormModes.edit) && 'none' };
};